module.exports = __webpack_public_path__ + "media/images/Carte-cadeaux-hortense-e88cfff776fb39fdaf15908641fb177e.webp";